import React from 'react';
import { EXIT_OVERLAY_CONTAINER_ID } from '../hooks/useScreenHeaderFocus';
var ExitOverlay = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { id: EXIT_OVERLAY_CONTAINER_ID, "data-testid": "ExitOverlay", style: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            background: 'white',
            zIndex: 999,
            // needed to allow <ScreenContainer> to fill 100% of this overlay's height
            display: 'flex',
        } }, children));
};
export default ExitOverlay;
